import { RouteType } from "types/RouteType";
import aiAgentRoute from "./AIAgent/AIAgent.Route";
import dashboardRoute from "./Dashboard/dashboard.Route";
import departmentsRoute from "./Departments/departments.Route";
import permissionsRoute from "./Permissions/permissions.Route";
import standardProceduresRoute from "./StandardProcedures/standardProcedures.Route";
import userManagementRoute from "./UserManagement/userManagement.Route";

const administrationRoutesList: RouteType[] = [
    // =========================================================================
    // ACTIVE ROUTES - Currently in use
    // =========================================================================
    ...dashboardRoute,  // Home page (/home)
    departmentsRoute,
    ...userManagementRoute,

    // =========================================================================
    // HIDDEN ROUTES - Not currently in use but available for future use
    // To re-enable: uncomment the route below and it will appear in navigation
    // =========================================================================
    // ...aiAgentRoute,          // AI Agent interface
    // ...permissionsRoute,      // Permission management
    // standardProceduresRoute,  // Standard procedures management
];

export default administrationRoutesList;
